import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'player',
      component: () => import(/* webpackChunkName: "player" */ './views/PlayerController.vue')
    },
    {
      path: '/board',
      name: 'BoardController',
      component: () => import(/* webpackChunkName: "board" */ './views/BoardController.vue')
    },
    {
      path: '/testing',
      name: 'testing',
      component: () => import(/* webpackChunkName: "board" */ './views/Testing.vue')
    }
  ]
})
